import { pipe } from 'fp-ts/function';
import { map, merge, reduce } from 'lodash/fp';

import { ResourcePricing, ServicePricingResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework/redux';

import {
    FETCH_RESERVATION_PRICING_FAILED,
    FETCH_RESERVATION_PRICING_STARTED,
    FETCH_RESERVATION_PRICING_SUCCEEDED,
} from '../entities/reservationPrices/actionTypes';
import { WithPricingHashes } from '../servicePricing';
import {
    fetchServicePricingFailed,
    fetchServicePricingStarted,
    fetchServicePricingSucceeded,
} from '../servicePricing/reducers';

import { CATEGORIES_VIEW_ERROR_DISSMISED } from './actionTypes';
import {
    getApplicableCancellationFees,
    servicePricingToPricing,
    setFailedPricingHashes,
    setStartedPricingHashes,
} from './utils';

const reduceWithIndex = (reduce as $TSFixMe).convert({ cap: false });

const INITIAL_STATE = {};

export const pricingReducer = createReducer(INITIAL_STATE, {
    [FETCH_RESERVATION_PRICING_STARTED]: (state: $TSFixMe, { pricingHashes }: $TSFixMe) =>
        setStartedPricingHashes(state, pricingHashes),
    // @ts-expect-error $TSFixMeError: A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
    [fetchServicePricingStarted]: (state: $TSFixMe, { pricingHashes }: $TSFixMe) =>
        setStartedPricingHashes(state, pricingHashes),
    [FETCH_RESERVATION_PRICING_SUCCEEDED]: (
        state: $TSFixMe,
        { pricingHashes, occupancyPrices, roomId, cancellationFees }: $TSFixMe
    ) =>
        reduceWithIndex(
            // @ts-expect-error $TSFixMeError: Parameter 'acc' implicitly has an 'any' type.
            (acc, hash, index) => {
                const rates = pipe(
                    occupancyPrices?.[index]?.pricing ?? [],
                    map(({ rateId: id, ...other }: ResourcePricing & { rateId: string }) => ({
                        id,
                        cancellationFees: getApplicableCancellationFees(id, roomId)(cancellationFees),
                        ...other,
                    })),
                    keyById
                );

                return {
                    ...acc,
                    [hash]: {
                        isFetching: false,
                        hasFailed: false,
                        rates,
                    },
                };
            },
            state,
            pricingHashes
        ),
    // @ts-expect-error $TSFixMeError: A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
    [fetchServicePricingSucceeded]: (
        state: $TSFixMe,
        { categoryPrices, pricingHashes, cancellationFees }: ServicePricingResult & WithPricingHashes
    ) => merge(state, servicePricingToPricing({ categoryPrices, pricingHashes, cancellationFees })),
    [FETCH_RESERVATION_PRICING_FAILED]: (state: $TSFixMe, { pricingHashes }: $TSFixMe) =>
        setFailedPricingHashes(state, pricingHashes),
    // @ts-expect-error $TSFixMeError: A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
    [fetchServicePricingFailed]: (state: $TSFixMe, { pricingHashes }: $TSFixMe) =>
        setFailedPricingHashes(state, pricingHashes),
    [CATEGORIES_VIEW_ERROR_DISSMISED]: () => INITIAL_STATE,
});
